export const PAGE_VIEWED = 'client_search_popover_viewed';
export const CLOSE_BUTTON_CLICKED = 'client_search_popover_close_clicked';
export const LOCATION_INPUT_UPDATED = 'client_search_popover_location_input_updated';
export const LOCATION_INPUT_CLICKED = 'client_search_popover_location_input_clicked';
export const LOCATION_ITEM_CLICKED = 'client_search_popover_location_suggestion_clicked';
export const QUERY_INPUT_CLICKED = 'client_search_popover_search_input_clicked';
export const SERVICE_ITEM_CLICKED = 'client_search_popover_service_item_clicked';
export const PRO_ITEM_CLICKED = 'client_search_popover_pro_item_clicked';
export const SEARCH_BTN_CLICKED = 'client_search_popover_btn_clicked';
export const SEARCH_POPOVER_SOURCE = 'search_popover_popover';
export const SEARCH_SUGGESTION_EXPANDED = 'client_search_popover_service_item_expanded';

export const USE_CURRENT_LOCATION_COPY = 'Use My Current Location';
export const LOADING_LOCATION_COPY = 'Finding your location...';

export const FIND_MY_LOCATION_CLICKED = 'client_search_popover_find_my_location_clicked';
export const FIND_MY_LOCATION_RESOLVED = 'client_search_popover_find_my_location_resolved';
export const FIND_MY_LOCATION_ERRORED = 'client_search_popover_find_my_location_errored';

export const POPULAR_SUGGESTIONS_EVENT = 'client_popular_matches_viewed';

export const CLIENT_SEARCH_EXPANSION_TEST_NAME = 'client_search_drilldown_atl4060_20211006';
export const CLIENT_SEARCH_EXPANSION_TEST_PERCENT = 0.5;
